import React, {Component} from "react";
import {Link} from "react-router-dom";
import { withTranslation } from 'react-i18next';

class PackageExpired extends Component {
    render() {
        const { t } = this.props;
        return (
            <>
            <div className="body-overlay active" id="body-overlay" />
                <div className="search-popup active" id="search-popup">
                    <form className="search-form">
                        <h3 className="title">
                            {t('lang.package_expired_title_text_your_package_has_expired')}
                        </h3>
                        <p>{t('lang.package_expired_description_text')}</p>
                        <Link className="float-right" to={'/'}>
                            <i className="fa fa-arrow-left" /> {t('lang.common_text_back')}
                        </Link>
                    </form>
            </div>

        </>
        );
    }
}

export default (withTranslation('common')(PackageExpired));